<template>
  <div class="articlePage pageWhite pagePadding">
    <div class="articleScreen" ref="screenWrap">
      <el-form :model="screenForm" inline ref="screenForm" small>
        <el-form-item label="学号" prop="studentNumber">
          <el-input placeholder="输入学号" v-model="screenForm.studentNumber" clearable style="width: 150px"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input placeholder="输入姓名" v-model="screenForm.name" clearable style="width: 150px"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input placeholder="输入身份证号" v-model="screenForm.idCard" clearable></el-input>
        </el-form-item>
        <el-form-item label="毕业年份" prop="graduation">
          <el-select v-model="screenForm.graduation" clearable style="width: 100px">
            <el-option v-for="item in graduationList" :key="item" :label="`${item}年`" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="毕业院校" prop="studentNumber">
          <el-select v-model="screenForm.university" filterable clearable>
            <el-option v-for="item in schoolList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业" prop="specializedId">
          <el-input placeholder="输入专业" v-model="screenForm.specializedId" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input placeholder="输入手机号" v-model="screenForm.phone" clearable style="width: 150px"></el-input>
        </el-form-item>
        <el-form-item label="家人电话" prop="familyPhone">
          <el-input placeholder="输入家人电话" v-model="screenForm.familyPhone" clearable style="width: 150px"></el-input>
        </el-form-item>
        <el-form-item label="申请时间" prop="createTime">
          <el-date-picker
            v-model="screenForm.createTime"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="table-header-datePicker"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="accountScrow" label="户口">
          <el-select v-model="screenForm.accountScrow" clearable style="width: 130px">
            <el-option label="申请托管" value="1"></el-option>
            <el-option label="未申请托管" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="微信号" prop="wechat">
          <el-input placeholder="输入微信号" v-model="screenForm.wechat" clearable style="width: 140px"></el-input>
        </el-form-item>
        <el-form-item label="QQ号" prop="qq">
          <el-input placeholder="输入QQ号" v-model="screenForm.qq" clearable style="width: 140px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="toSubmitScreen">查询</el-button>
          <el-button size="small" @click="toResetScreen">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="articleTable" :style="`height: ${tableHeight}px;`">
      <el-table :data="tableData" stripe header-row-class-name="table-header-bg" ref="applyTable" border
                :max-height="tableHeight" v-loading="isGetting" @selection-change="selectChange"
                @select="tableSelectFlag=false" @select-all="tableSelectFlag=false">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="70" label="序号">
          <template slot-scope="scope">{{ (currentPage - 1) * 20 + scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="学号" min-width="120" show-overflow-tooltip prop="studentNumber"></el-table-column>
        <el-table-column label="姓名" min-width="85" show-overflow-tooltip prop="name"></el-table-column>
        <el-table-column label="性别" min-width="75" prop="sex">
          <template slot-scope="scope">{{ scope.row.sex|sex }}</template>
        </el-table-column>
        <el-table-column label="身份证号" min-width="170" prop="idCard"></el-table-column>
        <el-table-column label="毕业年份" min-width="100" prop="graduation"></el-table-column>
        <el-table-column label="毕业院校" min-width="120" show-overflow-tooltip prop="universityName"></el-table-column>
        <el-table-column label="专业" min-width="110" show-overflow-tooltip prop="specializedId"></el-table-column>
        <el-table-column label="档案" min-width="80" prop="fileCustody">
          <template slot-scope="scope">{{ scope.row.fileCustody ? '已申请' : '未申请' }}</template>
        </el-table-column>
        <el-table-column label="户口" min-width="80" prop="accountScrow">
          <template slot-scope="scope">{{ scope.row.accountScrow ? '已申请' : '未申请' }}</template>
        </el-table-column>
        <el-table-column label="手机号" min-width="110" prop="phone"></el-table-column>
        <el-table-column label="申请时间" min-width="160" prop="createTime"></el-table-column>
        <el-table-column label="家人电话" min-width="110" prop="familyPhone"></el-table-column>
        <el-table-column label="微信号" min-width="120" show-overflow-tooltip prop="wechat"></el-table-column>
        <el-table-column label="QQ号" min-width="100" show-overflow-tooltip prop="qq"></el-table-column>
        <el-table-column label="来源" min-width="80" show-overflow-tooltip prop="source">
          <template slot-scope="scope">{{ scope.row.source|source }}</template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right" v-if="role!=3">
          <template slot-scope="scope">
            <el-button size="small" type="danger" plain @click="toDel(scope.row)" v-if="role==1">删除</el-button>
            <el-button size="small" type="primary" plain @click="toEdit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="articleFooter">
      <div class="tableSelect">
        <div class="ts-item" v-show="tableSelectArr.length">
          已选<span class="color-primary">{{ tableSelectArr.length }}</span>人
          <el-button size="mini" type="danger" @click="toDel('')" v-if="role==1">删除选中人员</el-button>
          <el-button type="primary" plain size="mini" @click="toExcel(2)">导出选中人员</el-button>
        </div>
        <el-button type="primary" size="mini" @click="toExcel(1)">导出全部</el-button>
        <template v-if="role==1">
          <el-button size="mini" type="success" @click="toImport">学生导入</el-button>
        </template>
      </div>
      <el-pagination background @current-change="currentChange" :pager-count="5" :total="totalSize" :page-size="20"
                     layout="total,prev,pager,next,jumper" :current-page="currentPage"></el-pagination>
    </div>
    <edit-apply :dialogShow="applyDialog" @close="applyDialog=false" @success="editSuccess"
                :data="applyData"></edit-apply>
    <downExcel :dialogShow="downDialog" v-on:loading-end="downDialog=false" :progress="progress"></downExcel>
  </div>
</template>

<script type="text/ecmascript-6">
import {mapState} from 'vuex'

const editApply = () => import('@/dialog/editApply')
const downExcel = () => import('@/dialog/downExcel')
export default {
  data () {
    return {
      screenWrap: 50,
      totalSize: 0,
      currentPage: 1, // 当前页码
      tableSelectFlag: false, // 表格数据循环开关
      tableSelectArr: [], // 表格选择数据
      tableSelectAll: {}, // 表格所有选择数据
      tableData: [],
      isGetting: false,
      screenForm: {
        studentNumber: '',
        name: '',
        idCard: '',
        phone: '',
        graduation: '',
        university: '',
        specializedId: '',
        createTime: [],
        familyPhone: '',
        accountScrow: '',
        wechat: '',
        qq: ''
      },
      toScreenForm: {},
      graduationList: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      applyDialog: false,
      downDialog: false,
      progress: 0,
      applyData: null
    }
  },
  computed: {
    tableHeight () {
      return window.innerHeight - 142 - this.screenWrap
    },
    ...mapState({
      role: state => state.base.userInfo.role,
      schoolList: state => state.school.schoolList
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.screenWrap = this.$refs.screenWrap.offsetHeight
    })
  },
  created () {
    this._toGetList()
    this.getGraduation()
  },
  methods: {
    getGraduation () {
      let ny = new Date().getFullYear()
      let nm = new Date().getMonth()
      ny = nm > 8 ? (ny + 1) : ny
      let arr = []
      for (let j = ny; j >= 1990; j--) {
        arr.push(j)
      }
      this.graduationList = arr
    },
    _toGetList (page) {
      this.isGetting = true
      this.currentPage = page || 1
      this.toScreenForm['page'] = this.currentPage
      this.toScreenForm['size'] = 20
      this.toScreenForm['isCurrent'] = 1
      this.$api.getApplyList(this.toScreenForm, (res) => {
        this.tableData = res.records
        this.totalSize = (typeof res.total === 'string') ? parseInt(res.total) : res.total
        this.$nextTick(() => {
          this.toMemoryTableSelect()
        })
      }, () => {
        this.isGetting = false
      })
    },
    toSubmitScreen () {
      let form = JSON.parse(JSON.stringify(this.screenForm))
      if (form.createTime && form.createTime.length) {
        form['startTime'] = form.createTime[0]
        form['endTime'] = form.createTime[1]
      }
      delete form['createTime']
      this.toScreenForm = form
      this._toGetList()
    },
    toResetScreen () {
      this.$refs['screenForm'].resetFields()
      this.toScreenForm = {}
      this._toGetList()
    },
    selectChange (v) { // 表格选择
      this.$nextTick(() => {
        if (!this.tableSelectFlag) {
          this.tableSelectAll['page_' + this.currentPage] = v
          this.tableSelectArr = []
          for (let k in this.tableSelectAll) {
            if (this.tableSelectAll[k] && this.tableSelectAll[k].length > 0) {
              this.tableSelectArr = this.tableSelectArr.concat(this.tableSelectAll[k])
            }
          }
        }
      })
    },
    currentChange (v) { // 分页点击
      this.tableSelectFlag = true // 当只是分页时，不需要去重新循环
      this._toGetList(v)
    },
    // 表格反选
    toMemoryTableSelect () {
      let currentArr = this.tableSelectAll['page_' + this.currentPage]
      if (currentArr && currentArr.length) {
        let dataIDS = this.tableData.map(L => L['sid'])
        currentArr.forEach((o) => {
          if (dataIDS.includes(o['sid'])) {
            this.$refs.applyTable.toggleRowSelection(this.tableData[dataIDS.indexOf(o['sid'])], true)
          }
        })
      }
    },
    // 判断移出表格选中
    toRemoveTableSelect (sid) {
      let oArr = this.tableSelectAll['page_' + this.currentPage] || []
      let nArr = []
      oArr.forEach((o) => {
        if (o.sid !== sid) {
          nArr.push(o)
        }
      })
      this.tableSelectAll['page_' + this.currentPage] = nArr
    },
    // 重置表格选中
    toReset () {
      this.tableSelectAll = {}
      this.tableSelectFlag = false
    },
    toEdit (obj) {
      this.applyData = JSON.parse(JSON.stringify(obj))
      this.applyDialog = true
    },
    editSuccess () {
      this._toGetList(this.currentPage)
      this.applyDialog = false
    },
    toDel (obj) {
      if (obj) {
        this.$confirm('确认删除:' + obj.name + '的申请,是否继续?', '删除申请', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.delApply(obj['sid'], () => {
            this.toRemoveTableSelect(obj['sid'])
            this.$message.success('删除成功！')
            this._toGetList(this.currentPage)
          })
        }).catch(() => {
        })
      } else {
        let ids = this.tableSelectArr.map(item => item.sid)
        if (ids.length > 0) {
          this.$confirm('确认删除选中这' + ids.length + '人的申请,是否继续?', '批量删除申请', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$api.delApply(ids.join(','), () => {
              this.toReset()
              this.$message.success('删除成功！')
              this._toGetList()
            })
          }).catch(() => {
          })
        }
      }
    },
    toExcel (type) {
      let json = {}
      if (type === 2) {
        let ids = this.tableSelectArr.map(item => item.sid)
        json['ids'] = ids.join(',')
      } else {
        json = JSON.parse(JSON.stringify(this.toScreenForm))
        delete json['page']
        delete json['size']
      }
      this.progress = 0
      this.downDialog = true
      this.$api.exportExcel(json, () => {
        this.progress = 100
      })
    },
    toImport () {
      this.$router.push({path: '/importStudent'})
    }
  },
  components: {
    editApply,
    downExcel
  },
  filters: {
    sex (s) {
      return ['', '男', '女'][s]
    },
    source (s) {
      return ['', '电脑', '手机', '导入'][s]
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/apply.vue